import { ThunkType } from "../../../../core/store/reducers";
import { dividendReport } from "../api/getdividendreport";
import fileDownload from "js-file-download";
import { setPrintDividendsFetchState } from "../dividendsDataSlice";
import { DividendData } from "../types";

export const printDividendThunk = (dividend?: DividendData): ThunkType => async (dispatch, getStore) => {
	const store = getStore();
	
	if (store.data.auth.current.status !== "successful" || !dividend || !dividend.tranId) {
		return undefined;
	}
	const lan = store.ux.localization.language
	const filename = `DividendConfirmation${lan.trim().toUpperCase()}_${dividend.tranId}.pdf`
	const user = store.data.auth.current.user;
	dispatch(setPrintDividendsFetchState({ type: "started" }));

	const dividendReports = await dispatch(dividendReport(user, dividend.tranId));
	if (dividendReports) {
		fileDownload(new Blob([dividendReports as any], { type: "application/pdf" }), filename);
	}
	dispatch(setPrintDividendsFetchState({ type: "not-started" }));
};
